import { render } from "./borderButton.vue?vue&type=template&id=41e34488&scoped=true&ts=true"
import script from "./borderButton.vue?vue&type=script&lang=ts"
export * from "./borderButton.vue?vue&type=script&lang=ts"

import "./borderButton.vue?vue&type=style&index=0&id=41e34488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e34488"]])

export default __exports__